import HttpRequest from "@/services/http_request";

class GatewayProvider extends HttpRequest {
  constructor() {
    super(process.env.VUE_APP_API_ENDPOINT);
  }

  async login(payload) {
    const { data } = await this.create("login", payload);
    return data;
  }

  async check(payload) {
    this.setHeader({
      Authorization: `Bearer ${this.variableParser(payload.token)}`
    });
    const { data } = await this.get("queue/check");
    return data;
  }

  async pingTest() {
    const { data } = await this.get("testapi");
    return data;
  }
}

export default GatewayProvider;
